import { AuthActionTypes, AuthActions } from './types';
import { Authentication } from '../../models/authentication';

const initialState: Authentication = {
  loading: false,
  authenticated: false,
  signUpPassword: '',
  token: '',
  verifiedOTP: false,
  verifiedOTPToken: '',
  error: undefined,
};

const authReducer = (state = initialState, action: AuthActions) => {
  switch (action.type) {
    // SIGNUP
    case AuthActionTypes.ACTION_AUTH_SIGNUP_INIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // LOGIN
    case AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.token,
        authenticated: true,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // LOGOUT
    case AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        token: '',
        authenticated: false,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // FORGOT PASSWORD
    case AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // SEND OTP
    case AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT:
      return {
        ...state,
        signUpPassword: action.payload.password || '',
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // VERIFY OTP
    case AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        verifiedOTPToken: action.payload.token,
        verifiedOTP: action.payload.token ? true : false,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // CHANGE PASSWORD
    case AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
  }
  return state;
};

export default authReducer;